export default __webpack_public_path__ + "static/media/T09B.b541830d.png";